import html2canvas from "html2canvas"
import { PDFHeader } from "../PDFHeader"
import { PDFFooter } from "../PDFFooter"

export const generateTopInstitutesPDF = async ({
  pdf,
  corporateData,
  instituteChartData,
  topInstitutesRef,
}) => {
  const element = topInstitutesRef?.current
  if (!element) return

  const startY = await PDFHeader({ pdf, corporateData })

  pdf.setFontSize(14)
  pdf.setFont(undefined, "bold")
  pdf.text("Top 10 Institute", 15, startY)

  pdf.setFontSize(10)
  pdf.setFont(undefined, "normal")
  pdf.text(
    "Data below shows the indication of company location by the amount spent",
    15,
    startY + 6
  )

  const chartElement = element.querySelector("canvas")?.parentNode?.parentNode

  const canvas = await html2canvas(chartElement, {
    scale: 3,
    useCORS: true,
  })

  const imgData = canvas.toDataURL("image/png")

  const pageWidth = pdf.internal.pageSize.getWidth()
  const pageHeight = pdf.internal.pageSize.getHeight()
  const maxImgWidth = Math.min(180, pageWidth - 30)
  const maxImgHeight = pageHeight * 0.40

  let imgWidth = maxImgWidth
  let imgHeight = (canvas.height * imgWidth) / canvas.width

  if (imgHeight > maxImgHeight) {
    imgHeight = maxImgHeight
    imgWidth = (canvas.width * imgHeight) / canvas.height
  }

  pdf.addImage(imgData, "PNG", 15, startY + 12, imgWidth, imgHeight)
  // ===== Legend (Applicants / Hires) =====
let legendY = startY + 12 + imgHeight + 5

// Applicants
pdf.setFillColor(160, 220, 252)
pdf.circle(20, legendY, 2, "F")
pdf.text("Applicants", 25, legendY + 1)

// Hires
pdf.setFillColor(0, 31, 84)
pdf.circle(80, legendY, 2, "F")
pdf.text("Hires", 85, legendY + 1)

  let currentY = startY + 12 + imgHeight + 18

  const instituteBarData = instituteChartData?.instituteBarChart || []
  const validInstitutes = instituteBarData.filter(
    (item) => item.institute && item.institute !== ""
  )

  const tableData = validInstitutes.slice(0, 10).map((item) => {
    // Use applicant gender analysis for the table
    const genderAnalysis = item.applicantGenderAnalysis || {}
    const men = genderAnalysis.men || 0
    const women = genderAnalysis.women || 0
    const others = genderAnalysis.others || 0

    return [
      item.institute || "Unknown Institute",
      item.hired || 0,
      item.applicants || 0,
      `Men: ${men}`,
      `Women: ${women}`,
      `Others: ${others}`,
    ]
  })

  pdf.autoTable({
    startY: currentY,
    head: [["Institutes", "Hires", "Applicants", "Gender", "", ""]],
    body: tableData,
    theme: "grid",
    styles: { fontSize: 10 },
    headStyles: {
      fillColor: [220, 220, 220],
      textColor: 0,
      fontStyle: "bold",
    },
    didParseCell: function (data) {
        // move header text slightly right
        if (data.section === "head" && (data.column.index === 1 || data.column.index === 2)) {
            data.cell.styles.cellPadding = { left: 7, top: 2, bottom: 2 }
        }

        // move gender text right for circle
        if (data.section === "body" && data.column.index >= 3) {
            data.cell.styles.cellPadding = { left: 7, top: 2, bottom: 2 }
        }
    },

    didDrawCell: function (data) {

        const { x, y, height } = data.cell
        const circleX = x + 3
        const circleY = y + height / 2
        const radius = 1

        // HEADER CIRCLES
        if (data.section === "head") {

            // Hires
            if (data.column.index === 1) {
                pdf.setFillColor(0, 27, 72) // #001B48
                pdf.circle(circleX, circleY, radius, "F")
            }

            // Applicants
            if (data.column.index === 2) {
                pdf.setFillColor(151, 202, 219) // #97CADB
                pdf.circle(circleX, circleY, radius, "F")
            }
        }

        // BODY CIRCLES
        if (data.section === "body" && data.column.index >= 3) {
            const text = data.cell.raw

            if (text?.startsWith("Men")) {
                pdf.setFillColor(0, 27, 72) // #001B48
                pdf.circle(circleX, circleY, radius, "F")
            }

            if (text?.startsWith("Women")) {
                pdf.setFillColor(1, 138, 190) // #018ABE
                pdf.circle(circleX, circleY, radius, "F")
            }

            if (text?.startsWith("Others")) {
                pdf.setFillColor(200, 200, 200) // #C8C8C8
                pdf.circle(circleX, circleY, radius, "F")
            }
        }
    }
  })

  await PDFFooter({ pdf })
}